<br><br>
<app-gestiones-header-preca [buttonselected]=4 [participante]="participante" [gestionSeleccionada]="gestionSeleccionada" (selecttab)="selectedtab($event)" (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
    <div class="row table-full">
        <div class="table-data">
            <div class="cabecera-gris">
                <h1>INFORME DE BURO EXTERNO - SIB-</h1>
            </div>
            <div class="cabecera-outline">
                <h1>ENDEUDAMIENTO DIRECTO</h1>
            </div>
            <div class="table4" *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje != null
              && gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.endeudaDirecto.length > 0">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <th>Nombre de la Entidad</th>
                      <th>Código Estado</th>
                      <th>Estado</th>
                      <th>Código Tipo Activo</th>
                      <th>Activo</th>
                      <th>Código Tipo Garantía</th>
                      <th>Garantía</th>
                      <th>Categoría</th>
                      <th>Código Moneda</th>
                      <th>Moneda</th>
                      <th>Capital Original</th>
                      <th>Saldo</th>
                      <th>Fecha Concesión</th>
                      <th>Vencimiento</th>
                      <th>Forma Pago Del Capital</th>
                      <th>Forma Pago del Interés</th>
                      <th>Situación</th>
                    </tr>
                    <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.endeudaDirecto">
                      <td>{{element.nomEntidad}}</td>
                      <td>{{element.codEstado}}</td>
                      <td>{{element.descEstado}}</td>
                      <td>{{element.codTipoActivo}}</td>
                      <td>{{element.descTipoActivo}}</td>
                      <td>{{element.codTipoGara}}</td>
                      <td>{{element.descTipoGara}}</td>
                      <td>{{element.categoria}}</td>
                      <td>{{element.codMoneda}}</td>
                      <td>{{element.descMoneda}}</td>
                      <td>{{element.capitalOrig| currency:"Q "}}</td>
                      <td>{{element.saldo| currency:"Q "}}</td>
                      <td>{{element.fecconce.toString()}}</td>
                      <td>{{element.fecvence.toString()}}</td>
                      <td>{{element.fpagocap}}</td>
                      <td>{{element.fpagoint}}</td>
                      <td>{{element.situacion}}</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <p *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje==null
              || gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.endeudaDirecto.length==0">
              No hay información de Endeudamiento Directo.
            </p>
            <div class="cabecera-outline">
                <h1>ENDEUDAMIENTO INDIRECTO</h1>
            </div>
            <div class="table4" *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje !=null &&  gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.endeudaIndirecto.length>0">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <th>Nombre de la Entidad</th>
                    <th>Código Estado</th>
                    <th>Estado</th>
                    <th>Código Tipo Activo</th>
                    <th>Activo</th>
                    <th>Código Tipo Garantía</th>
                    <th>Garantía</th>
                    <th>Categoría</th>
                    <th>Código Moneda</th>
                    <th>Moneda</th>
                    <th>Capital Original</th>
                    <th>Saldo</th>
                    <th>Fecha Concesión</th>
                    <th>Vencimiento</th>
                    <th>Forma Pago Del Capital</th>
                    <th>Forma Pago del Interés</th>
                    <th>Situación</th>
                  </tr>
                  <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.endeudaIndirecto">
                    <td>{{element.nomEntidad}}</td>
                    <td>{{element.codEstado}}</td>
                    <td>{{element.descEstado}}</td>
                    <td>{{element.codTipoActivo}}</td>
                    <td>{{element.descTipoActivo}}</td>
                    <td>{{element.codTipoGara}}</td>
                    <td>{{element.descTipoGara}}</td>
                    <td>{{element.categoria}}</td>
                    <td>{{element.codMoneda}}</td>
                    <td>{{element.descMoneda}}</td>
                    <td>{{element.capitalOrig| currency:"Q "}}</td>
                    <td>{{element.saldo| currency:"Q "}}</td>
                    <td>{{element.fecconce}}</td>
                    <td>{{element.fecvence}}</td>
                    <td>{{element.fpagocap}}</td>
                    <td>{{element.fpagoint}}</td>
                    <td>{{element.situacion}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
          <p *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje==null
            || gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.endeudaIndirecto.length==0">
            No hay información de Endeudamiento Indirecto.
          </p>
        </div>
    </div>
    <div class="row table-media">
      <div class="col-md-6">
        <div class="table-data" style="margin-left: auto; margin-bottom: 15px;">
          <div class="table2" *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje != null
            &&  gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.histEndeudaDirecto.length>0">
            <table class="table table-borderless">
              <thead class="thead-light">
                <tr>
                  <th colspan="8" scope="col">HISTORIAL ENDEUDAMIENTO DIRECTO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Nit</th>
                  <th>Fecha</th>
                  <th>Total</th>
                  <th colspan="2">Máximo Morosidad en Meses</th>
                  <th colspan="2">Total de Morosidad</th>
                  <th>Clasificación</th>
                </tr>
                <tr>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Capital</th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Intereses</th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Capital</th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Intereses</th>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                </tr>
                <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.histEndeudaDirecto">
                  <td>{{element.nit}}</td>
                  <td>{{setFormatDate(element.fecha)}}</td>
                  <td>{{element.totDeuda}}</td>
                  <td>{{element.maxMoroCapital}}</td>
                  <td>{{element.maxMoroIntereses}}</td>
                  <td>{{element.totMoroCapital}}</td>
                  <td>{{element.totMoroIntereses}}</td>
                  <td>{{element.peorCalificacion}}</td>
                </tr>
              </tbody>
            </table>
        </div>
        <p *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje == null
          || gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.histEndeudaDirecto.length === 0">
          No hay información de Historial de Endeudamiento Directo.
        </p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="table-data">
          <div class="table2" *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje != null
          && gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.histEndeudaIndirecto.length > 0">
            <table class="table table-borderless">
              <thead class="thead-light">
                <tr>
                  <th colspan="8" scope="col">HISTORIAL ENDEUDAMIENTO INDIRECTO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Nit</th>
                  <th>Fecha</th>
                  <th>Total</th>
                  <th colspan="2">Máximo Morosidad en Meses</th>
                  <th colspan="2">Total de Morosidad</th>
                  <th>Clasificación</th>
                </tr>
                <tr>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Capital</th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Intereses</th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Capital</th>
                  <th style="border-bottom: solid 1px #d4d4d5;">Intereses</th>
                  <th style="border-bottom: solid 1px #d4d4d5;"></th>
                </tr>
                <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.histEndeudaIndirecto">
                  <td>{{element.nit}}</td>
                  <td>{{setFormatDate(element.fecha)}}</td>
                  <td>{{element.totDeuda}}</td>
                  <td>{{element.maxMoroCapital}}</td>
                  <td>{{element.maxMoroIntereses}}</td>
                  <td>{{element.totMoroCapital}}</td>
                  <td>{{element.totMoroIntereses}}</td>
                  <td>{{element.peorCalificacion}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje==null || gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.histEndeudaIndirecto.length==0">No hay información de Historial de Endeudamiento Indirecto.</p>
        </div>
      </div>
    </div>
    <div class="row table-full">
      <div class="table-data">
          <div class="cabecera-gris">
              <h1>INFORME DE BURO EXTERNO - SIB-</h1>
          </div>
          <div class="cabecera-outline">
              <h1>ACTIVOS CANCELADOS CONTRA RESERVA Y ADJUDICACIONES</h1>
          </div>
          <div class="table4" *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje !=null && gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.activosCanceladosReserva.length>0">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <th>No.</th>
                    <th>Nombre Entidad</th>
                    <th>Fecha de Cancelación</th>
                    <th>Forma Cancelación</th>
                    <th>Código Forma Cancelación</th>
                    <th>Capital Original</th>
                    <th>Fecha Saldo Capital</th>
                    <th>Monto Saldo Capital</th>
                  </tr>
                  <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.activosCanceladosReserva;let i = index">
                    <td>{{i+1}}</td>
                    <td>{{element.nomEntidad}}</td>
                    <td>{{this.setFormatDate(element.fechaCancelacion)}}</td>
                    <td>{{element.formaCancelacion}}</td>
                    <td>{{element.codigoFormaCancelacion}}</td>
                    <td>{{element.capitalOriginal| currency:"Q "}}</td>
                    <td>{{element.fechaSaldoCapital}}</td>
                    <td>{{element.montoSaldoCapital| currency:"Q "}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total</td>
                    <td>{{gestionSeleccionada.participante[this.participante].outSumatoriaSaldoCCR| currency:"Q "}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
          <p *ngIf="gestionSeleccionada.participante[this.participante].sircRuta12.mensaje==null || gestionSeleccionada.participante[this.participante].sircRuta12.mensaje.contenido.activosCanceladosReserva.length==0">No hay información de Activos Cancelados Contra Reserva.</p>
          <div class="cabecera-outline">
              <h1>COMPORTAMIENTO DE CREDITOS VIGENTES Y CANCELADOS</h1>
          </div>
          <div class="table4" *ngIf="listvigentesycancelados.length>0">
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <th>No.</th>
                  <th>Nombre Entidad</th>
                  <th>Tipo de vinculo</th>
                  <th>Tipo de Activo</th>
                  <th>Tipo de Garantía</th>
                  <th>Moneda</th>
                  <th>Capital Original</th>
                  <th>Saldo</th>
                  <th>Saldo Vencido</th>
                  <th>Fecha Activo</th>
                  <th>Comportamiento de moras</th>
                  <th>Categoría</th>
                  <th>Fecha Otorgado</th>
                  <th>Fecha Vencimiento</th>
                  <th>Estado del Crédito</th>
                </tr>
                <tr *ngFor="let element of listvigentesycancelados; let i=index">
                  <td >{{i+1}}</td>
                  <td>{{element.nomEntidad}}</td>
                  <td>{{element.nomVinculo}}</td>
                  <td>{{element.descTipoActivo}}</td>
                  <td>{{element.descTipoGarantia}}</td>
                  <td>{{element.descMoneda}}</td>
                  <td>{{element.capitalOrig| currency:"Q "}}</td>
                  <td>{{element.saldo| currency:"Q "}}</td>
                  <td>{{element.vencido| currency:"Q "}}</td>
                  <td>{{setFormatDate(element.fechaact)}}</td>
                  <td style="max-width: 20px;word-break: break-word;">{{element.comportamiento}}</td>
                  <td>{{element.categoria}}</td>
                  <td>{{element.fecconce}}</td>
                  <td>{{element.fecvence}}</td>
                  <td>{{element.estado}}</td>
                </tr>
              </tbody>
            </table>
        </div>
        <p *ngIf="listvigentesycancelados.length==0">No hay información de Endeudamiento Directo.</p>
      </div>
  </div>
</div>
